import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import CalendarPage from "@/pages/CalendarPage";
import MyBookings from "@/pages/MyBookings";
import AdminRooms from "@/pages/admin/Rooms";
import AdminCompanies from "@/pages/admin/Companies";
import AdminUsers from "@/pages/admin/Users";
import AdminDisplays from "@/pages/admin/Displays";
import AdminSettings from "@/pages/admin/Settings";
import DisplayKiosk from "@/pages/DisplayKiosk";
import Layout from "@/components/Layout";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-slate-500" data-testid="loading-state">Indlæser…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public kiosk */}
            <Route path="/display/:code" element={<DisplayKiosk />} />

            {/* Auth */}
            <Route path="/login" element={<Login />} />

            {/* App */}
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<CalendarPage />} />
              <Route path="bookings" element={<MyBookings />} />
              <Route
                path="admin/rooms"
                element={
                  <Protected adminOnly>
                    <AdminRooms />
                  </Protected>
                }
              />
              <Route
                path="admin/companies"
                element={
                  <Protected adminOnly>
                    <AdminCompanies />
                  </Protected>
                }
              />
              <Route
                path="admin/users"
                element={
                  <Protected adminOnly>
                    <AdminUsers />
                  </Protected>
                }
              />
              <Route
                path="admin/displays"
                element={
                  <Protected adminOnly>
                    <AdminDisplays />
                  </Protected>
                }
              />
              <Route
                path="admin/settings"
                element={
                  <Protected adminOnly>
                    <AdminSettings />
                  </Protected>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
